class Select{
    constructor(el) {
        this.$box = $(el);
        this.$opener = this.$box.find('.select__btn-opener');
        this.$list = this.$box.find('.select__list');
        this.$item = this.$box.find('.select__item');
        this.isFlag = false;

        this.bindEvnet();
    }

    open(){
        this.isFlag = true;
        if( this.$box.hasClass('active') ){
            this.close();
        }
        else{
            this.$box.css('zIndex', 11).addClass('active');
            this.$list.show();
        }
    }
    close(){
        this.isFlag = false;
        this.$list.hide();
        this.$box.css('zIndex', 1).removeClass('active').blur();
    }
    change(t){
        this.$opener.html( $(t).html() );
        this.close();
    }
    bindEvnet(){
        this.$opener.on('click', (e) => this.open(e.target) );
        this.$list.on('click', (e) => {
            if( $(e.target).is('a') ){
                this.change(e.target)
            }
            else {
                this.change( $(e.target).parents('a')[0] )
            }
        });
        this.$box.on('focusout', (e)=>{
            setTimeout(()=>{
                if( this.isFlag ) this.close();
            }, 150)
        });
    }
}


export default Select;


// WEBPACK FOOTER //
// ./src/js/util/multiSelect.js